<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="agents"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="id_tour"
      show-expand
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Data Invoice</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Data Tour"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.status_payment`]="{ item }">
        <v-btn
          :color="getColor(item.status_payment)"
          rounded
          small
          dark
          @click="SetStatus(item.id_tour)"
        >
          {{ item.status_payment }}
        </v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-row>
            <v-col>
              <v-simple-table>
                <thead>
                  <tr
                    class="font-weight-bold text-h6  "
                  >
                    <td>
                      <v-btn
                        text
                        dark
                        v-bind="attrs"
                        v-on="on"
                      >
                        Date Payment
                      </v-btn>
                    </td>
                    <td>
                      <span class=" text-h6 ">:  {{item.date_payment}} - {{item.ket_payment}}</span>
                    </td>
                  </tr>

                  <tr class="font-weight-bold text-h6  ">
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Exchange Rate
                          </v-btn>
                        </template>
                        <span>Exchange Rate </span>
                      </v-tooltip>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.exchange_rate).toLocaleString() }}</span>
                    </td>
                  </tr>

                  <tr class="font-weight-bold text-h6  ">
                    <td>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Total Cost
                          </v-btn>
                        </template>
                        <span>Cost Before Markup</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.total_cost).toLocaleString() }} - $ {{ Number(item.total_cost/item.exchange_rate).toLocaleString() }}</span>
                    </td>
                  </tr>
                 <tr
                    class="font-weight-bold text-h6  "
                  >
                    <td>
                      <v-tooltip
                        top
                        color="primary"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            text
                            dark
                            v-bind="attrs"
                            v-on="on"
                          >
                            Final Cost
                          </v-btn>
                        </template>
                        <span>Cost After Markup</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.total_markup).toLocaleString() }} - $ {{ Number(item.total_markup/item.exchange_rate).toLocaleString() }}</span>
                    </td>
                  </tr>

                  <tr class="font-weight-bold text-h6 bg-gradient-primary ">
                    <td>
                      <span class="  text-h6 ">Margin </span>
                    </td>
                    <td>
                      <span class=" text-h6 ">: Rp. {{ Number(item.margin).toLocaleString() }}</span>
                    </td>
                  </tr>
                </thead>
              </v-simple-table>
            </v-col>
          </v-row>
        </td>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="editItem(item)"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="LihatTour(item)"
        >
          <v-icon>{{ icons.mdiEyeCircle }}</v-icon>
        </v-btn>
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="Cetak(item)"
        >
          <v-icon>{{ icons.mdiPrinter }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialog3"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      @click:outside="CekDialog()"
    >
      <v-card>
        <v-card-title class="text-h5  bg-gradient-primary">
          <v-btn
            icon
            dark
            @click="CekDialog()"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>

          <span>Tour {{ data.guest_name }}</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col>
              <DataService :item="data" />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog4"
      width="400px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Enter The Bank Remitance </span>
        </v-card-title>
        <v-card-text>
          <v-currency-field
            v-model="itemcetak.bank_remitance"
            prefix="$"
            type="number"
            hide-details
            dense
            outlined
            placeholder="Enter the Bank Remitance"
            label="Enter the Bank Remitance"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary text-capitalize"
            @click="CetakInvoice()"
          >
            Cetak Invoice <v-icon>{{ icons.mdiPrinter }}</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogstatus"
      scrollable
      max-width="400px"
    >
      <v-card>
        <v-card-title>Select Status Tour</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-select
            v-model="status"
            dense
            outlined
            :items="['Waiting For Payment','Paid','Canceled']"
          />
          <v-menu
            v-if="status== 'Paid'"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date_payment"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-if="status == 'Paid'"
                v-model="date_payment"
                label="Date Payment"
                readonly
                dense
                outlined
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date_payment"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Cancel
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.menu.save(date_payment)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-textarea
            v-if="status == 'Paid'"
            v-model="ket_payment"
            dense
            outlined
            label="Keterangan Payment"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            class="ml-auto"
            color="primary"
            @click="ChangeStatusPayment()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
  mdiEyeCircle,
  mdiPrinter,
} from '@mdi/js'
import DataService from './DataService.vue'

export default {
  components: { DataService },
  data() {
    return {
      status: '',
      date_payment: '',
      ket_payment: '',
      idtour: '',
      dialogstatus: false,
      dialog3: false,
      dialog4: false,
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
        mdiEyeCircle,
        mdiPrinter,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      data: [],
      form: {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Tour Code', value: 'tour_code' },
        { text: 'Guest Name', value: 'guest_name' },
        { text: 'Travel Date', value: 'travel_date' },
        { text: 'Cut off Date', value: 'cut_off_date' },
        { text: 'Status Payment', value: 'status_payment' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 250,
        },
      ],
      agents: [],
      regions: [],
      itemcetak: {
        id_tour: '',
        bank_remitance: 25,
      },
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Agent' : 'Edit Agent'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Agent' : 'Update Agent'
    },
  },
  mounted() {
    this.initialize()
    this.initializeregion()
  },
  methods: {
    getColor(status) {
      if (status === 'Canceled') {
        return 'error'
      }
      if (status === 'Paid') {
        return 'primary'
      }

      if (status === 'Waiting For Payment') {
        return 'warning'
      }

      return 'error'
    },
    ChangeStatusPayment() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/ChangeStatusPayment', {
        id_tour: this.idtour, status: this.status, datepayment: this.date_payment, ketpayment: this.ket_payment,
      }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialogstatus = false
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    SetStatus(idtour) {
      this.idtour = idtour
      this.dialogstatus = true
    },
    Cetak(item) {
      this.itemcetak.id_tour = item.id_tour
      this.dialog4 = true
    },
    CetakInvoice() {
      if (this.itemcetak.bank_remitance > 0) {
        window.open(`${process.env.VUE_APP_apiURL}/api/CetakInvoice/?id=${this.itemcetak.id_tour}&bank_remitance=${this.itemcetak.bank_remitance}`, '_blank')
      } else {
        this.$root.$emit('PesanResponse', 'Please Type Exchange Rate', 'red')
      }
    },
    ChangeStatusTour(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/ChangeStatusTour', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    LihatTour(data) {
      this.dialog3 = true
      this.data = data
    },
    initializeregion() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Region').then(response => {
        this.regions = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    CekDialog() {
      this.form = {
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        city: '',
        note: '',
      }
      this.dialog3 = false
    },
    editItem(item) {
      this.$router.push({ path: 'NewTour', query: { id_tour: item.id_tour } })
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteAgent', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/Invoice').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.agents = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveAgent', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
